import { render } from "./form-block.vue?vue&type=template&id=56fee770"
import script from "./form-block.vue?vue&type=script&lang=js"
export * from "./form-block.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__